// extracted by mini-css-extract-plugin
export default {"dialog_container":"ConfirmModal_dialog_container__6qxlQ","dialog_header":"ConfirmModal_dialog_header__T0cfY"};